import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevision: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTelevision"><Path d="M2 3V17H22V3H2Z" fill="currentColor"/><Path d="M6.32527 20.9456C8.10831 20.3323 10.0158 20 12 20C13.9842 20 15.8917 20.3323 17.6747 20.9456L18.6204 21.2709L19.2709 19.3796L18.3253 19.0544C16.3363 18.3702 14.2091 18 12 18C9.79087 18 7.66371 18.3702 5.67473 19.0544L4.72911 19.3796L5.37965 21.2709L6.32527 20.9456Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelevision;
